import { render, staticRenderFns } from "./VehicleIndex.vue?vue&type=template&id=3d218579&scoped=true"
import script from "./VehicleIndex.vue?vue&type=script&lang=js"
export * from "./VehicleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d218579",
  null
  
)

export default component.exports